import { FC } from 'react'
import { Outlet } from 'react-router-dom'

const Home: FC = () => {
  return <Outlet />
}

export default Home
